"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProjectedScaledValues = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var get_chart_id_1 = require("../../../../state/selectors/get_chart_id");
var compute_series_geometries_1 = require("./compute_series_geometries");
var get_geometries_index_keys_1 = require("./get_geometries_index_keys");
var get_oriented_projected_pointer_position_1 = require("./get_oriented_projected_pointer_position");
exports.getProjectedScaledValues = re_reselect_1.default([get_oriented_projected_pointer_position_1.getOrientedProjectedPointerPositionSelector, compute_series_geometries_1.computeSeriesGeometriesSelector, get_geometries_index_keys_1.getGeometriesIndexKeysSelector], function (_a, _b, geometriesIndexKeys) {
    var x = _a.x, y = _a.y, verticalPanelValue = _a.verticalPanelValue, horizontalPanelValue = _a.horizontalPanelValue;
    var _c = _b.scales, xScale = _c.xScale, yScales = _c.yScales;
    if (!xScale) {
        return;
    }
    var xValue = xScale.invertWithStep(x, geometriesIndexKeys);
    if (!xValue) {
        return;
    }
    return {
        x: xValue.value,
        y: __spread(yScales.entries()).map(function (_a) {
            var _b = __read(_a, 2), groupId = _b[0], yScale = _b[1];
            return { value: yScale.invert(y), groupId: groupId };
        }),
        smVerticalValue: verticalPanelValue,
        smHorizontalValue: horizontalPanelValue,
    };
})(get_chart_id_1.getChartIdSelector);
//# sourceMappingURL=get_projected_scaled_values.js.map